/**
 * @file 线上/线上环境配置
 * @author haoyan@baidu.com
 */

// ------- 线上 ---------
// mars页中异步请求host
let apiHost = 'https://expert.baidu.com';
// const apiHost = 'http://yq01-ps-galaxy-offline-m12xi3-agent13.yq01.baidu.com:8501'
// 跳转的mars页的origin和path
const viewHost = 'https://expert.baidu.com';
const viewPath = '/med/template/#';

//  跳转的sf页的origin
const npHost = 'https://m.baidu.com';
// 请求付费链接
const cpcHost = 'https://carp.baidu.com';
// wyw请求付费链接
const wywHost = 'https://zhidao.baidu.com/nchat/openapi/getshangacpc';
// const wywHost = 'http://bjyz-ps-beehive-agent100004.bjyz.baidu.com:8719/nchat/openapi/getshangacpc';
// const cpcHost = 'http://gzhxy-map-bus-bus045.gzhxy.baidu.com:8990';

// 解决跨域问题
apiHost = '';

// 后续可能用到，暂时用youjia的代替
export const TOKEN = {
  ios: '2_f28337cdc9ab5a04cbe63f4db6acc240',
  android: '1_f28337cdc9ab5a04cbe63f4db6acc240'
};
export const APIS = {
  favor: `${apiHost}/law/api/question`,
  openapi: `${cpcHost}/openapi`
};

// 获取地理编码ak
export const MAP_AK = 'lzSwxbfYRy2VDoqrWb6PcxUDFIiWdPLv';
// 获取地理编码sk
export const MAP_SK = 'mL7jaFuKl01I367vk5gqDzGGDPG2TuZT';
export default {
  apiHost,
  viewHost,
  viewPath,
  npHost,
  cpcHost,
  wywHost
};